import { useCallback, useEffect, useRef, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { styled } from "@mui/material";
import { api } from "api";
import { Loader, SmallText } from "components";
import { storage } from "utils/localStorage";

const KYD_SYNC_STATUS = {
  FAILED: "failed",
  SUCCESS: "connected",
  NOT_FOUND: "not_found",
};

const ContainerStyled = styled("div")({
  "& .note": {
    fontStyle: "italic",
    marginBottom: "1rem",
  },
  "& .link-instructions": {
    fontSize: "13px",
    marginTop: "1rem",
  },
});

const SyncKydLinkSection = ({ userId, opekepeLink, onSync }) => {
  const { t } = useTranslation();
  const pollingRef = useRef();
  const [isLoading, setIsLoading] = useState(true);

  const fetchSyncStatus = useCallback(async () => {
    if (!userId) {
      setIsLoading(false);
      return;
    }

    const { data, error } = await api.opekepe.checkSyncUser(userId);

    if (error) {
      console.error(error);
      setIsLoading(false);
      return;
    }
    if (data.status !== KYD_SYNC_STATUS.SUCCESS) {
      setIsLoading(false);
      return;
    }

    const { data: accountData, error: accountError } =
      await api.opekepe.getSyncedAccount(userId);
    if (accountData) {
      storage.saveSyncedUser({ id: userId });
    }

    onSync?.({ data: accountData, error: accountError });
    clearInterval(pollingRef.current);
    setIsLoading(false);
  }, [userId, onSync]);

  useEffect(() => {
    if (typeof fetchSyncStatus === "function") {
      pollingRef.current = setInterval(() => {
        fetchSyncStatus();
      }, 3000);
    }

    return () => {
      if (pollingRef.current) clearInterval(pollingRef.current);
    };
  }, [fetchSyncStatus]);

  return (
    <ContainerStyled>
      {isLoading ? (
        <Loader size="40px" />
      ) : (
        <>
          <SmallText className="note">
            {t("OpekepeSync.IcognitoBtn.Note")}
          </SmallText>
          <a
            href={opekepeLink}
            target="_blank"
            rel="noreferrer noopener"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
          >
            {t("OpekepeSync.IcognitoBtn.Title")}
          </a>
          <SmallText className="link-instructions">
            <Trans i18nKey="OpekepeSync.IcognitoBtn.Subtitle" />
          </SmallText>
          <br />
          <SmallText>{t("OpekepeSync.IcognitoBtn.Disclaimer")}</SmallText>
        </>
      )}
    </ContainerStyled>
  );
};
export default SyncKydLinkSection;
